import React from 'react';
import JsonView from './JsonView';
import Util from '../Util';
import $ from 'jquery';

class SheldonStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      path: '',
      content: '',
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleButtonClick(type) {
    let { ip } = this.props.hostInfo;
    let hostInfo = this.props.hostInfo;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let linuxdash = Util.getLinuxDashPath(hostInfo);
    let path = `${linuxdash}/server/?module=${type}`; // LinuxDash module

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    $.ajax({ url: path, dataType: 'json', timeout: 60000 })
      .always(() => {
        this.inProgress = false;
      })
      .done((data) => {
        let content = (
          <JsonView title={path} data={data} shouldExpandNode={() => true} raw={true} />
        );

        this.setState({
          content: content,
        });
      })
      .fail((jqXHR) => {
        this.setState({
          content: jqXHR.responseText,
        });
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { type } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>Linux Stats</h2>
        <div style={{ margin: '20px 0' }}>
          For getting info about processes, load and network info.
        </div>
        <div className='sheldon-buttons'>
          {[
            'load_avg',
            'current_ram',
            'cpu_utilization',
            'cpu_intensive_processes',
            'ram_intensive_processes',
            'memory_info',
            'disk_partitions',
            'swap',
          ].map((module) => {
            return (
              <button
                className={type == module ? 'pure-button pure-button__selected' : 'pure-button'}
                key={module}
                onClick={this.handleButtonClick.bind(this, module)}
              >
                {module}
              </button>
            );
          })}
          <div>
            {[
              'network_connections',
              'arp_cache',
              'ping',
              'bandwidth',
              'internet_speed',
              'upload_transfer_rate',
              'download_transfer_rate',
              'io_stats',
            ].map((module) => {
              return (
                <button
                  className={type == module ? 'pure-button pure-button__selected' : 'pure-button'}
                  key={module}
                  onClick={this.handleButtonClick.bind(this, module)}
                >
                  {module}
                </button>
              );
            })}
          </div>
          <div>
            {[
              'port_check_amazon_mq',
              'port_check_apriva',
              'port_check_artifactory',
              'port_check_tally',
              'lshw',
              'logged_in_users',
              'user_accounts',
            ].map((module) => {
              return (
                <button
                  className={type == module ? 'pure-button pure-button__selected' : 'pure-button'}
                  key={module}
                  onClick={this.handleButtonClick.bind(this, module)}
                >
                  {module}
                </button>
              );
            })}
          </div>
          <div>
            {[
              'linuxdash_ver',
              'fingerprint',
              'ip',
              'hostname',
              'iface',
              'macaddress',
              'basic_info',
              'kiosk_info',
              'kiosk-stats',
            ].map((module) => {
              return (
                <button
                  className={type == module ? 'pure-button pure-button__selected' : 'pure-button'}
                  key={module}
                  onClick={this.handleButtonClick.bind(this, module)}
                >
                  {module}
                </button>
              );
            })}
          </div>
        </div>
        <div className='sheldon-content sheldon-stats'>
          <pre style={{ height: panelHeight - 400, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </pre>
        </div>
      </div>
    );
  }
}

export default SheldonStats;



// WEBPACK FOOTER //
// ./src/components/SheldonStats.js